// extracted by mini-css-extract-plugin
export default {"wrapper":"x4-z","play":"y4-z"};